import { Injectable } from "@angular/core";
import { ShareMessageRepo } from "@app/core/share-message/domain/share-message.repo";
import { ShareMessageDesktopWeb } from "@app/core/share-message/infrastructure/desktop-web/share-message.desktop-web";

import { Observable } from "rxjs";

@Injectable()
export class ShareMessageDesktopWebImplRepo implements ShareMessageRepo {
  constructor(private shareMessageDesktopWeb: ShareMessageDesktopWeb) {}

  shareMessage(message: string, url: string): Observable<string> {
    return this.shareMessageDesktopWeb.execute(message, url);
  }
}
